var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoAddCalendarNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "33px",
    viewBox: "0 0 29 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shipment1-Copy-2",
    transform: "translate(-799.000000, -306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(800.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4012451,25.5 L2,25.5 C0.8954305,25.5 0,24.6045695 0,23.5 L0,3.5 C0,2.3954305 0.8954305,1.5 2,1.5 L19,1.5 C20.1045695,1.5 21,2.3954305 21,3.5 L21,18.8168945",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 1,
    width: 1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 10,
    y: 1,
    width: 1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 16,
    y: 1,
    width: 1,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(4.500000, 8.873535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.5 L12,0.5",
    id: "Path-113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5.12646484 L7.95019531,5.12646484",
    id: "Path-113-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.1264648 L8.5,10.1264648",
    id: "Path-113-Copy-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(14.000000, 18.500000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 Z M5.9,6 L2.7,6 L2.7,8.1328125 L5.9,8.1328125 L5.9,11.3152344 L8.0328125,11.3152344 L8.0328125,8.1328125 L11.3152344,8.1328125 L11.3152344,6 L8.0328125,6 L8.0328125,2.7 L5.9,2.7 L5.9,6 Z",
    id: "Combined-Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAddCalendarNote);
export default __webpack_public_path__ + "static/media/ico_add_calendar_note.d7de678746828a46b8cb2641c6e9dcf7.svg";
export { ForwardRef as ReactComponent };